import whenDomReady from 'when-dom-ready';
function initialise() {
    const bizform = document.querySelector('.js-bizform');
    if (!bizform) {
        return;
    }
    const form = bizform.querySelector('form');
    if (!form) {
        return;
    }
    // Redirect url stored in bizform properties
    const redirectUrl = bizform.dataset.formRedirectUrl;
    // Hash change event listener
    window.addEventListener('hashchange', () => {
        if (location.hash === '#success' && redirectUrl !== undefined) {
            const emailField = form.querySelector('input[type *= email]');
            const phoneField = form.querySelector('input[type *= tel]');
            const companyField = form.querySelector('input[name *= Company]');
            const firstNameField = form.querySelector('input[name *= FirstName]');
            const lastNameField = form.querySelector('input[name *= LastName]');
            const countryField = form.querySelector('select[name *= CountryName]');
            let email = null;
            let phone = null;
            let company = null;
            let firstName = null;
            let lastName = null;
            let country = null;
            if (emailField != null) {
                email = emailField.value;
            }
            if (phoneField != null) {
                phone = phoneField.value;
            }
            if (companyField != null) {
                company = companyField.value;
            }
            if (firstNameField != null) {
                firstName = firstNameField.value;
            }
            if (lastNameField != null) {
                lastName = lastNameField.value;
            }
            if (countryField != null) {
                const sel = countryField.selectedIndex;
                const opt = countryField.options[sel];
                country = opt.value;
            }
            if (typeof window.dataLayer != 'undefined') {
                window.dataLayer.push({
                    event: 'action.lead_form',
                    user: {
                        email: email,
                        phone: phone,
                        company: company,
                        fname: firstName,
                        lname: lastName,
                        countryCode: country,
                    },
                    eventCallback: function () {
                        window.location.href = redirectUrl;
                    },
                    eventTimeout: 1000,
                });
            }
            else {
                window.location.href = redirectUrl;
            }
            //
        }
        else {
            const hashPairs = getHashes();
            if (hashPairs) {
                const submissionGuidHash = hashPairs[1][0]?.toLowerCase();
                const submissionGuidHashValue = hashPairs[1][1];
                if (submissionGuidHash == 'submissionguid' && submissionGuidHashValue !== undefined) {
                    window.location.href =
                        '/special-pages/calendly-1on1-demo-scheduler?submissionGuid=' + submissionGuidHashValue;
                }
            }
        }
    });
    // Load event listener
    window.addEventListener('load', () => {
        // Get the language variant from data attribute
        const languageVariant = bizform.getAttribute('data-form-language-variant');
        // German texts modifications
        if (languageVariant == 'de') {
            const consentLabel = document.querySelector('.js-consent label');
            if (consentLabel) {
                consentLabel.innerHTML =
                    'Ich stimme der Verwendung meiner Daten für <a href=\'/privacy-policy\' rel="noreferrer noopener" tabindex="-1" target="_blank">Marketing- und Vertriebsmitteilungen</a> (z. B. gezielte, personalisierte E-Mail-Nachrichten) von Kentico Software s.r.o. zu.';
            }
        }
        // Hashes in URL
        const hashPairs = getHashes();
        if (!hashPairs) {
            return;
        }
        const successHash = hashPairs[0][0];
        if (successHash == 'success') {
            bizform.innerHTML =
                "<div>The form has been already submitted.</div><br /><div>Click <a href='" +
                    location.protocol +
                    '//' +
                    location.host +
                    location.pathname +
                    "''>here</a> to submit another one.</div>";
        }
    });
    //  Get hashes in URL
    function getHashes() {
        if (!location.hash) {
            return;
        }
        const hashPairs = location.hash
            .substr(1)
            .split('&')
            .map(function (pair) {
            const kv = pair.split('=', 2);
            return [decodeURIComponent(kv[0]), kv.length === 2 ? decodeURIComponent(kv[1]) : null];
        });
        return hashPairs;
    }
}
whenDomReady().then(initialise);
